import React, { useEffect, useState } from "react";
import supabase from "../../../supabaseClient";

const MediaTab = ({ event }) => {
  const [mediaPosts, setMediaPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMediaPosts = async () => {
      setLoading(true);
      if (!event?.id) {
        setMediaPosts([]);
        setLoading(false);
        return;
      }
      // Fetch posts for the event with media
      const { data: posts, error } = await supabase
        .from("posts")
        .select("id, user_id, media_url, media_type, created_at")
        .eq("event_id", event.id)
        .not("media_url", "is", null);
      if (error) {
        console.error('Error fetching media for event:', error);
        setMediaPosts([]);
        setLoading(false);
        return;
      }
      // Generate public URLs for media
      const postsWithPublicUrls = await Promise.all(
        posts
          .filter(
            post => post.media_url && (post.media_type?.startsWith("image") || post.media_type?.startsWith("video"))
          )
          .map(async post => {
            let publicUrl = post.media_url;
            if (post.media_url && !/^https?:\/\//.test(post.media_url)) {
              const { data } = supabase.storage.from("post-media").getPublicUrl(post.media_url);
              if (data?.publicUrl) {
                publicUrl = data.publicUrl;
              }
            }
            return { ...post, media_url: publicUrl };
          })
      );
      setMediaPosts(postsWithPublicUrls);
      setLoading(false);
    };
    if (event?.id) fetchMediaPosts();
  }, [event]);

  return (
    <div className="event-media-tab">
      <h2>Event Media</h2>
      <div className="media-grid">
        {loading ? (
          <div>Loading media...</div>
        ) : mediaPosts.length > 0 ? (
          mediaPosts.map(post => (
            <div className="media-card" key={post.id}>
              {post.media_type.startsWith("image") ? (
                <img src={post.media_url} alt="media" className="media-img" />
              ) : post.media_type.startsWith("video") ? (
                <video src={post.media_url} controls className="media-video" />
              ) : null}
              <div className="media-meta">
                <span className="media-author">{post.user_id}</span>
                <span className="media-date">{new Date(post.created_at).toLocaleString()}</span>
              </div>
            </div>
          ))
        ) : (
          <div>No media found for this event.</div>
        )}
      </div>
    </div>
  );
};

export default MediaTab;